<div class="col-md-12">
	<form #customerForm="ngForm" (ngSubmit)="saveCustomer()" validate-form="editCustomer" [innerModelGroups]="['customerInputs']">
		<app-customer-edit [customer]="customer" [enterpriseList]="enterprisesList"></app-customer-edit>
		<div class="mt-3">
			<button type="submit" class="btn btn-primary mr-2">{{'g.submit' | translate}}</button>
			<button type="button" class="btn btn-default" (click)="goBack()">{{'g.cancel' | translate}}</button>
		</div>
	</form>
</div>